/**
 * vendor
 */
import React from 'react';
import i18n from "i18n";
import Cookies from 'js-cookie';

/**
 * Main info loader
 * 
 * Initializes language from cookie on first load.
 * User data is stored in localStorage after login and doesn't need to be fetched on every page load.
 *
 * @class  InfoLoad (name)
 * @return {boolean}
 */
function InfoLoad(props) {
  React.useEffect(() => {
    // Initialize language from cookie if i18n hasn't been set yet
    // This means nothing has loaded yet, so we can instruct first load to
    // set it, otherwise there might be some users that already configured
    // the language so we don't touch it if it's not en-US
    if (i18n.language == 'en-US') {
      const lang = Cookies.get('sportsbook_country_id') || "en";
      i18n.changeLanguage(lang);
      document.body.parentElement.lang = lang;
    }
  }, []);

  return (<></>);
}

export default InfoLoad;
